module.exports = __webpack_public_path__ + "img/card-text.1e958b41.svg";